import React from "react";

/**
 * Renders a PageSpeed summary, per device. Expects the shape returned by
 * aggregator.site_health.pagespeed_current:
 *   { mobile: { performance_score, lcp_ms, cls, inp_ms, samples }, desktop: {…} }
 */
export default function PageSpeedCard({ pagespeed }) {
  const devices = Object.entries(pagespeed || {});
  if (devices.length === 0) {
    return <div className="empty">No PageSpeed data yet. Run the pagespeed collector.</div>;
  }
  return (
    <div className="ps-grid">
      {devices.map(([device, m]) => (
        <div key={device} className="ps-device">
          <div className="ps-device-name">{device}</div>
          <div className="ps-score">
            <span className={`ps-score-ring ${scoreBucket(m.performance_score)}`}>
              {Math.round(m.performance_score)}
            </span>
            <span className="subtle">/ 100</span>
          </div>
          <div className="ps-vitals">
            <Vital label="LCP" value={msToSeconds(m.lcp_ms)} unit="s" target={[2.5, 4]} raw={m.lcp_ms / 1000} />
            <Vital label="CLS" value={m.cls?.toFixed ? m.cls.toFixed(3) : m.cls} target={[0.1, 0.25]} raw={m.cls} />
            <Vital label="INP" value={m.inp_ms ? `${m.inp_ms}` : "—"} unit="ms" target={[200, 500]} raw={m.inp_ms} />
          </div>
          <div className="subtle" style={{ marginTop: 8, fontSize: 12 }}>
            {m.samples} page{m.samples === 1 ? "" : "s"} sampled
          </div>
        </div>
      ))}
    </div>
  );
}

function Vital({ label, value, unit, target, raw }) {
  const status = raw == null || raw === 0 ? "na" :
    raw <= target[0] ? "good" :
    raw <= target[1] ? "warn" : "bad";
  return (
    <div className={`vital vital-${status}`}>
      <div className="vital-label">{label}</div>
      <div className="vital-value">{value}{unit && value !== "—" ? unit : ""}</div>
    </div>
  );
}

function scoreBucket(score) {
  if (score == null) return "na";
  if (score >= 90) return "good";
  if (score >= 50) return "warn";
  return "bad";
}

function msToSeconds(ms) {
  if (ms == null || ms === 0) return "—";
  return (ms / 1000).toFixed(2);
}
